import Parse from 'parse'
import moment from 'moment-timezone'

moment.locale('es')
moment.tz.setDefault('America/Mexico_City')

class User extends Parse.User {
  
  constructor() {
    super('_User')
  }

  get createdAt () {
    return moment(this.get('createdAt')).format('dddd DD MMMM, YYYY')
  }

  get fullname(){
    return `${this.get('name')} ${this.get('lastName')}`
  }

  get username(){
    return this.get('username')
  }
  
  get email(){
    return this.getEmail()
  }

  get wishList(){
    return this.get('wishLists')
  }

  get position(){
    return this.get('position')
  }

  get league(){
    return this.get('league')
  }
  
  get team(){
    return this.get('team')
  }

  get name(){
    return this.get('name')
  }

  get function(){
    return this.get('position')
  }

  get role(){
    return this.get('role')
  }


  //--- Serch User
  static detail(id){
    const query = new Parse.Query(this)
    //query.include("WishList");

    return query.get(id)
  }

  //--- Relations and pointers  
  loadWish() {
    return this.relation('wishLists').query().find()
  }


  loadWhishlist(user) {
    console.log(user.id)
    //return this.relation('WishList').query().find()
    const query = new Parse.Query('WishList');
    return query.get(user.id)

  }

  /*loadAddress(appo){
    var query = new Parse.Query('Address');
    return query.get(appo.address.id)
  }*/

  //--Save


  

  static logIn(params){

    return Parse.Cloud.run('logIn', params)
  }

  static closeSession(params){
    return Parse.Cloud.run('closeSession', params)
  }


  static saveUser(params){

    return Parse.Cloud.run('signUp', params)
  }

  //-- Load Info
  static load (limit = 2000, skip = 0) {
    return new Parse.Query(this)
      .limit(limit)
      .skip(skip)
      .descending('createdAt')
      //.equalTo('role.id', "6Wk2ojqf4D")
      .find()
  }

  
  //-- CloudFunctions
  static convertStylist(user) {
    //eslint-disable-next-line
    const params = { user_id: user.id, is_professional: false }
    return Parse.Cloud.run('', params)
  }

  static forRelation() {
    return new Parse.Query(this)
      .equalTo('role', { "__type": "Pointer", "className": "_Role", "objectId": this.roleUser})
      .count()
  }

  static removeUserList(params) {
    return Parse.Cloud.run('removeUser', params)
  }

  dump(){
    console.log(this)
  }

}

export default User
